export type ImageFile = string | ArrayBuffer;

export enum ImageAspectRatio {
	Square = 1,
	Ratio16by9 = 16 / 9,
	Header = 55 / 18,
	Logo = 3.5,
}

export enum ImageShape {
	Rectangular,
	Circlular,
}

export interface IImageSpecification {
	key: string;
	title: string;
	shape: ImageShape;
	aspectRatio: ImageAspectRatio;
	minimumWidth?: number;
	allowedExtensions: string[];
}
